import { GeoJSONConverter } from '@datum-group/datum-map/lib';
import olGeoJSONFormat from 'ol/format/GeoJSON';
import { IMarker, MapMarker, MarkerOptions, StyleVariant } from './MapMarker';
import { INIT_MAP_DATA } from '@project/store';

export class GeoJSONMapMarkerAdapter implements IMarker<GeoJSON.Geometry> {
  private _mapMarker: MapMarker;

  constructor(options: MarkerOptions) {
    this._mapMarker = new MapMarker(options);
  }

  create = (geom: GeoJSON.Geometry, style?: StyleVariant) => {
    const converter = new GeoJSONConverter();

    // TODO: Вынести многократно дублирующуюся логику в проекте
    const convertedGeom = converter.convertGeometry(
      'EPSG:4326',
      INIT_MAP_DATA.srid,
      geom,
    );

    const format = new olGeoJSONFormat();
    const feature = format.readFeatures(convertedGeom);

    this._mapMarker.create(feature, style);
  };

  remove = () => {
    this._mapMarker.remove();
  };
}
